import type { Components } from '@mui/material'

export const MuiAutocomplete: Components['MuiAutocomplete'] = {
  defaultProps: { size: 'small' },
}
